import { create } from 'zustand';

const useModalStore = create((set) => ({
    isOpen: false,
    title: '',
    content: '',
    callback: () => {},

    actions: {
        setIsOpen: (data) => set((state) => ({ isOpen: data })),
        toggle: () => set((state) => ({ isOpen: !state.isOpen })),

        setTitle: (data) => set((state) => ({ title: data })),
        setContent: (data) => set((state) => ({ content: data })),
        setCallback: (data) => set((state) => ({ callback: data })),
    },
}));

export const useModal = () => useModalStore((state) => state);
